<template>
  <CommonIconLabel :icon="icon" :size="size">
    <div class="label-email">
      <p>{{ text }}</p>
    </div>
  </CommonIconLabel>
</template>

<script setup lang="ts">
import type { Icons } from '@/components/common/CommonIcon.vue'
import CommonIconLabel from '@/components/common/CommonIconLabel.vue'
import { ArrowUpRight } from 'lucide-vue-next'

withDefaults(
  defineProps<{
    text: string
    size: 'small' | 'medium'
    icon: Icons
  }>(),
  {
    size: 'small'
  }
)
</script>

<style scoped>
.label-email {
  display: flex;
  align-items: center;
  cursor: default;
}
</style>
